<template>
  <right-panel :datas="options" @onClose="onCloseForm" ref="right-panel-add">
    <div slot="header">
      <translate>Instance Detail</translate>
    </div>
    <div slot="content" class="cloud-wrapper">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane :label="attrText.baseInfo" name="baseInfo">
          <div v-if="!basicInfo.show" v-loading="!basicInfo.show" style="height: 300px">
          </div>
          <div v-if="basicInfo.show">
            <div class="info-content">
              <h4 class="info-title">
                <translate>Information</translate>
              </h4>
              <ul>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>Instance ID</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err">{{options.instanceId}}</el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>Instance Name</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err">{{basicInfo.Instances.InstanceName}}</el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>Zone</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err">{{basicInfo.ZoneName}}</el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>Region</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err">{{basicInfo.RegionName}}</el-col>
                </li>
              </ul>
            </div>
            <div class="info-content">
              <h4 class="info-title">
                <translate>Configuration Information</translate>
              </h4>
              <ul>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>CPU</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err">{{basicInfo.Instances.Cpu}}  core</el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>RAM</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err">{{basicInfo.Memory}}</el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>Public Network IP</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err && basicInfo.Instances.InstanceNetworkType == 'vpc'">{{basicInfo.Instances.EipAddress.IpAddress}}</el-col>
                  <el-col :span="17" v-if="!basicInfo.err && basicInfo.Instances.InstanceNetworkType != 'vpc'">{{basicInfo.Instances.PublicIpAddress.IpAddress.join(',')}}</el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>Intranet IP</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err && basicInfo.Instances.InstanceNetworkType == 'vpc'">{{basicInfo.Instances.VpcAttributes.PrivateIpAddress.IpAddress[0]}}</el-col>
                  <el-col :span="17" v-if="!basicInfo.err && basicInfo.Instances.InstanceNetworkType != 'vpc'">{{basicInfo.Instances.InnerIpAddress.IpAddress.join(',')}}</el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>System Disk</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err">{{`${diskCategory[basicInfo.systemDisk.Category]} ${basicInfo.systemDisk.Size}GB`}}
                  </el-col>
                </li>
                <li>
                  <el-col :span="7" class="info-name">
                    <translate>Data Disk</translate>
                    :
                  </el-col>
                  <el-col :span="17" v-if="!basicInfo.err" class="ak-defined">
                    <div v-if="basicInfo.systemDisk.DiskId && (!basicInfo.dataDisk || basicInfo.dataDisk.length == 0)"> - </div>
                    <div v-for="(disk,index) in basicInfo.dataDisk" :key="index">{{disk.category ? `${diskCategory[disk.category]} ${disk.size}GB` : '-'}}</div>
                  </el-col>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="attrText.monitorInfo" name="monitorInfo">
          <div class="select-time">
            <el-select v-model="monitorInfo.selectTime" @change="onSelectTime">
              <el-option :label="attrText.onehour" value="oneHour"></el-option>
              <el-option :label="attrText.sixhour" value="sixHour"></el-option>
              <el-option :label="attrText.oneday" value="oneDay"></el-option>
              <el-option :label="attrText.sevenday" value="sevenDay"></el-option>
            </el-select>
          </div>
          <div v-if="!monitorInfo.show" v-loading="!monitorInfo.show" style="height: 300px">
          </div>
          <div v-if="monitorInfo.show && monitorInfo.err" style="line-height: 100px;text-align: center">
            <translate>No Monitoring Information Is Available</translate>
          </div>
          <div class="show-chart" v-if="monitorInfo.show && !monitorInfo.err" v-loading="!monitorInfo.show">
            <div class="chart-item">
              <h3 class="chart-title"><translate>CPU Monitoring</translate></h3>
              <nvd3-line-chart v-if="monitorInfo.cpuData" :options="monitorInfo.cpuData.options"
                               :data="monitorInfo.cpuData.data"></nvd3-line-chart>
            </div>
            <div class="chart-item">
              <h3 class="chart-title"><translate>Network Monitoring</translate></h3>
              <nvd3-line-chart v-if="monitorInfo.netData" :options="monitorInfo.netData.options"
                               :data="monitorInfo.netData.data"></nvd3-line-chart>
            </div>
            <div class="chart-item">
              <h3 class="chart-title"><translate>Disk Monitoring</translate></h3>
              <nvd3-line-chart v-if="monitorInfo.diskData" :options="monitorInfo.diskData.options"
                               :data="monitorInfo.diskData.data"></nvd3-line-chart>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer">
      <el-button type="success" @click="onShowDialog(1)" :disabled="basicInfo.err || basicInfo.Instances.Status === 'Running' || basicInfo.Instances.Status === 'Stopping' || basicInfo.Instances.Status === 'Starting'">
        <translate>Start</translate>
      </el-button>
      <el-button type="info" @click="onShowDialog(2)" :disabled="basicInfo.err || basicInfo.Instances.Status === 'Stopped' || basicInfo.Instances.Status === 'Stopping' || basicInfo.Instances.Status === 'Starting'">
        <translate>Reboot</translate>
      </el-button>
      <el-button type="danger" @click="onShowDialog(3)" :disabled="basicInfo.err || basicInfo.Instances.Status !== 'Running' || basicInfo.Instances.Status === 'Starting' || basicInfo.Instances.Status === 'Stopping'">
        <translate>Stop</translate>
      </el-button>
      <span v-if="basicInfo.Instances.Status !== 'Running' && basicInfo.Instances.Status !== 'Stopped'" style="margin-left: 10px; color: red;">
        <translate v-if="basicInfo.Instances.Status === 'Stopping'">The Instance Is Stopping</translate>
        <translate v-if="basicInfo.Instances.Status === 'Starting'">The Instance Is Starting Up</translate>
      </span>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  import Nvd3LineChart from '../../common/nvd3-line-chart'
  import d3 from 'd3'
  export default{
    name: 'ClusterCloudAk',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        options: null,
        activeName: 'baseInfo',
        basicInfo: {
          Instances: {},
          regions: [],
          zones: [],
          systemDisk: {},
          dataDisk: [],
          show: false,
          err: false,
          ZoneName: '',
          RegionName: ''
        },
        monitorInfo: {
          selectTime: 'oneHour',
          netLoadCount: 0,
          options: {
            StartTime: new Date(new Date().getTime() - (1 * 60 * 60 * 1000)),
            EndTime: new Date(new Date().getTime() - (7 * 1000)),
            Period: 60
          },
          instanceStatusInterval: null,
          show: false,
          cpuData: null,
          netData: null,
          diskData: null,
          err: false
        },
        diskCategory: {
          cloud: this.$gettext('cloud'),
          cloud_efficiency: this.$gettext('cloud_efficiency'),
          cloud_ssd: this.$gettext('cloud_ssd'),
          ephemeral_ssd: this.$gettext('ephemeral_ssd'),
          ephemeral: this.$gettext('ephemeral')
        },
        xAxis: []
      }
    },
    computed: {
      attrText () {
        return this.getTransitionText()
      }
    },
    created () {
      setTimeout(() => {
        this.getRegions()
      }, 300)
    },
    methods: {
      getTransitionText () {
        return {
          baseInfo: this.$gettext('Basic Information'),
          monitorInfo: this.$gettext('Monitoring Information'),
          onehour: this.$gettext('One Hour'),
          sixhour: this.$gettext('Six Hours'),
          oneday: this.$gettext('One Day'),
          sevenday: this.$gettext('Seven Days')
        }
      },
      tabClick (v) {
        if (v.name === 'monitorInfo' && !this.monitorInfo.netData) {
          this.getEcsMonitorData()
        }
      },
      // 获取地域
      getRegions () {
        this.basicInfo.show = false
        let params = {
          id: this.options.resourceId,
          params: {
            Action: 'DescribeRegions'
          }
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then(res => {
          this.basicInfo.regions = res.Regions.Region
          this.getZones()
        }).catch(() => {
          this.basicInfo.show = true
          this.basicInfo.err = true
        })
      },
      // 获取可用区
      getZones () {
        let params = {
          id: this.options.resourceId,
          params: {
            Action: 'DescribeZones'
          }
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then(res => {
          this.basicInfo.zones = res.Zones.Zone
          this.getInstanceAttr()
        })
      },
      // 获取实例详情
      getInstanceAttr () {
        let params = {
          id: this.options.resourceId,
          params: {
            Action: 'DescribeInstances',
            InstanceIds: JSON.stringify([this.options.instanceId])
          }
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then(res => {
          this.basicInfo.Instances = Object.clone(res.Instances.Instance[0])
          if (this.basicInfo.Instances) {
            if (this.basicInfo.Instances.Status !== 'Running' && this.basicInfo.Instances.Status !== 'Stopped') {
              this.loadInstanceStatus()
            }
            if (parseInt(this.basicInfo.Instances.Memory) > 712) {
              this.basicInfo.Memory = parseInt(this.basicInfo.Instances.Memory) / 1024 + 'GB'
            } else {
              this.basicInfo.Memory += 'MB'
            }
            this.basicInfo.regions.forEach(region => {
              if (region.RegionId === this.basicInfo.Instances.RegionId) {
                this.basicInfo.RegionName = region.LocalName
              }
            })
            this.basicInfo.zones.forEach(zone => {
              if (zone.ZoneId === this.basicInfo.Instances.ZoneId) {
                this.basicInfo.ZoneName = zone.LocalName
              }
            })
            this.basicInfo.show = true
          }
        })
        this.getEcsDiskData()
      },
      // 获取磁盘信息
      getEcsDiskData () {
        let params = {
          id: this.options.resourceId,
          params: {
            Action: 'DescribeDisks'
          }
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then(res => {
          if (res.Disks.Disk) {
            let diskArr = res.Disks.Disk
            diskArr.forEach((disk) => {
              if (disk.Type === 'system') {
                this.basicInfo.systemDisk = disk
              } else {
                console.log('this.basicInfo.dataDisk', this.basicInfo.dataDisk)
                let dataDiskIndex = this.basicInfo.dataDisk.findIndex((item) => {
                  return item.category === disk.Category
                })
                if (dataDiskIndex < 0) {
                  this.basicInfo.dataDisk.push({'category': disk.Category, 'size': disk.Size})
                } else {
                  this.basicInfo.dataDisk[dataDiskIndex].size = parseInt(this.basicInfo.dataDisk[dataDiskIndex].size) + parseInt(disk.Size)
                }
              }
            })
          }
          console.log('this.basicInfo.systemDisk', this.basicInfo.systemDisk, this.basicInfo.dataDisk)
        })
      },
      // 查询监控数据
      getEcsMonitorData () {
        this.monitorInfo.show = false
        let params = {
          id: this.options.resourceId,
          params: {
            Action: 'DescribeInstanceMonitorData'
          }
        }
        params.params = Object.assign({}, params.params, {
          StartTime: this.monitorInfo.options.StartTime.iso().replace(/\.\d{3}Z/, 'Z'),
          EndTime: this.monitorInfo.options.EndTime.iso().replace(/\.\d{3}Z/, 'Z'),
          Period: this.monitorInfo.options.Period
        })
        this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then(res => {
          console.log('sevenDay', this.monitorInfo.selectTime)
          if (this.monitorInfo.selectTime === 'sevenDay') {
            this.monitorInfo.netLoadCount += 1
            let _data = []
            if (res.MonitorData && res.MonitorData.InstanceMonitorData) {
              _data = _data.concat(res.MonitorData.InstanceMonitorData)
            }
            if (this.monitorInfo.netLoadCount === 7) {
              if (_data.length > 0) {
                this.monitorInfo.cpuData = this.getCpuOptions(this.getCpuData(res.MonitorData.InstanceMonitorData))
                this.monitorInfo.netData = this.getNetOptions(this.getNetData(res.MonitorData.InstanceMonitorData))
                this.monitorInfo.diskData = this.getdiskOptions(this.getdiskData(res.MonitorData.InstanceMonitorData))
              }
            }
          } else {
            if (res.MonitorData && res.MonitorData.InstanceMonitorData && res.MonitorData.InstanceMonitorData.length > 0) {
              this.monitorInfo.cpuData = this.getCpuOptions(this.getCpuData(res.MonitorData.InstanceMonitorData))
              this.monitorInfo.netData = this.getNetOptions(this.getNetData(res.MonitorData.InstanceMonitorData))
              this.monitorInfo.diskData = this.getdiskOptions(this.getdiskData(res.MonitorData.InstanceMonitorData))
            }
          }
          this.monitorInfo.show = true
        }).catch(() => {
          this.monitorInfo.show = true
          this.monitorInfo.err = true
        })
      },
      getCpuData (data) {
        let totalOutFlow = []
        data.sort((a, b) => {
          return new Date(a.TimeStamp).getTime() - new Date(b.TimeStamp).getTime()
        })
        data.forEach((item, index) => {
          item._time = new Date(item.TimeStamp).getTime()
          totalOutFlow.push({
            x: item._time,
            xLabel: item._time,
            y: item.CPU || 0
          })
        })
        return [totalOutFlow]
      },
      getCpuOptions (chartData) {
        const colors = ['#729AFC']
        let _maxValue = d3.max(chartData[0], (vItem) => {
          return vItem.y
        })
        const totalChartData = {
          options: {
            chart: {
              showLegend: true,
              showControls: false,
              showMinMaxPoints: false,
              height: 200,
              margin: {
                top: 20,
                right: 20,
                bottom: 40,
                left: 60
              },
              x: (d) => d.x,
              y: (d) => d.y,
              useInteractiveGuideline: true,
              xAxis: {
                showMaxMin: false,
                tickFormat: (d, x, y) => {
                  let t = new Date(d)
                  if (x === undefined && x) {
                    let _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours()
                    let _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes()
                    return (t.getMonth() + 1) + '/' + t.getDate() + ' ' + _H + ':' + _M
                  } else {
                    if (t.getHours() === 0 && t.getMinutes() === 0) {
                      return (t.getMonth() + 1) + '/' + t.getDate()
                    } else {
                      let _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours()
                      let _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes()
                      return _H + ':' + _M
                    }
                  }
                }
              },
              yDomain: _maxValue > 10 ? [0, _maxValue + Math.floor(_maxValue / 7)] : [0, 10],
              yAxis: {
                showMaxMin: false,
                tickFormat: (d) => {
                  return d
                }
              }
            }
          },
          data: []
        }
        chartData.forEach((item, index) => {
          totalChartData.data.push({
            values: item,
            key: this.$gettext('Cpu usage (%)'),
            color: colors[index],
            area: true
          })
        })
        console.log('totalcputData', totalChartData)
        return totalChartData
      },
      getNetData (data) {
        let totalOutFlow = []
        let totalInFlow = []
        data.sort((a, b) => {
          return new Date(a.TimeStamp).getTime() - new Date(b.TimeStamp).getTime()
        })
        data.forEach((item, index) => {
          item._time = new Date(item.TimeStamp).getTime()
          this.xAxis.push(item._time)
          totalOutFlow.push({
            x: index,
            xLabel: item._time,
            y: item.IntranetTX || 0
          })
          totalInFlow.push(
            {
              x: index,
              xLabel: item._time,
              y: item.IntranetRX || 0
            }
          )
        })
        return [totalOutFlow, totalInFlow]
      },
      getNetOptions (chartData) {
        const colors = ['#729AFC', '#A2F1AF']
        const totalChartData = {
          options: {
            chart: {
              showLegend: true,
              showControls: false,
              showMinMaxPoints: false,
              height: 200,
              margin: {
                top: 20,
                right: 20,
                bottom: 40,
                left: 60
              },
              x: (d) => d.x,
              y: (d) => d.y,
              useInteractiveGuideline: true,
              xAxis: {
                showMaxMin: false,
                tickFormat: (d, x, y) => {
                  let t = new Date(this.xAxis[d])
                  if (x === 0 && x) {
                    let _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours()
                    let _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes()
                    return (t.getMonth() + 1) + '/' + t.getDate() + ' ' + _H + ':' + _M
                  } else {
                    if (t.getHours() === 0 && t.getMinutes() === 0) {
                      return (t.getMonth() + 1) + '/' + t.getDate()
                    } else {
                      let _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours()
                      let _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes()
                      return _H + ':' + _M
                    }
                  }
                }
              },
              yAxis: {
                showMaxMin: false,
                tickFormat: (d) => {
                  let t = Math.floor(d)
                  return t
                }
              }
            }
          },
          data: []
        }
        chartData.forEach((item, index) => {
          totalChartData.data.push({
            values: item,
            key: index === 0 ? this.$gettext('Total Out Flow (kbytes)') : this.$gettext('Total In Flow (kbytes)'),
            color: colors[index],
            area: true
          })
        })
        console.log('totalChartData', totalChartData)
        return totalChartData
      },
      getdiskData (data) {
        let BPSRead = []
        let BPSWrite = []
        data.sort((a, b) => {
          return new Date(a.TimeStamp).getTime() - new Date(b.TimeStamp).getTime()
        })
        data.forEach((item, index) => {
          item._time = new Date(item.TimeStamp).getTime()
          BPSRead.push({
            x: item._time,
            xLabel: item._time,
            y: item.BPSRead
          })
          BPSWrite.push(
            {
              x: item._time,
              xLabel: item._time,
              y: item.BPSWrite || 0
            }
          )
        })
        return [BPSRead, BPSWrite]
      },
      getdiskOptions (chartData) {
        const colors = ['#729AFC', '#A2F1AF']
        const totalChartData = {
          options: {
            chart: {
              showLegend: true,
              showControls: false,
              showMinMaxPoints: false,
              height: 200,
              margin: {
                top: 20,
                right: 20,
                bottom: 40,
                left: 60
              },
              x: (d) => d.x,
              y: (d) => d.y,
              useInteractiveGuideline: true,
              xAxis: {
                showMaxMin: false,
                tickFormat: (d, x, y) => {
                  let t = new Date(d)
                  if (x === 0 && x) {
                    let _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours()
                    let _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes()
                    return (t.getMonth() + 1) + '/' + t.getDate() + ' ' + _H + ':' + _M
                  } else {
                    if (t.getHours() === 0 && t.getMinutes() === 0) {
                      return (t.getMonth() + 1) + '/' + t.getDate()
                    } else {
                      let _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours()
                      let _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes()
                      return _H + ':' + _M
                    }
                  }
                }
              },
              yAxis: {
                showMaxMin: false,
                tickFormat: (d) => {
                  return parseFloat((d / 1024).toFixed(2))
                }
              }
            }
          },
          data: []
        }
        chartData.forEach((item, index) => {
          totalChartData.data.push({
            values: item,
            key: index === 0 ? this.$gettext('Disk Read Bandwidth (KByte/s)') : this.$gettext('Disk write bandwidth (KByte/s)'),
            color: colors[index],
            area: true
          })
        })
        return totalChartData
      },
      // 选择时间段
      onSelectTime (v) {
        console.log('v', v)
        if (v === 'oneHour') {
          this.monitorInfo.options = Object.assign({}, this.monitorInfo.options, {
            StartTime: new Date(new Date().getTime() - (1 * 60 * 60 * 1000)),
            EndTime: new Date(new Date().getTime() - (7 * 1000)),
            Period: 60
          })
        } else if (v === 'sixHour') {
          this.monitorInfo.options = Object.assign({}, this.monitorInfo.options, {
            StartTime: new Date(new Date().getTime() - (6 * 60 * 60 * 1000)),
            EndTime: new Date(new Date().getTime() - (7 * 1000)),
            Period: 600
          })
        } else if (v === 'oneDay') {
          this.monitorInfo.options = Object.assign({}, this.monitorInfo.options, {
            StartTime: new Date(new Date().getTime() - (24 * 60 * 60 * 1000)),
            EndTime: new Date(new Date().getTime() - (7 * 1000)),
            Period: 3600
          })
        } else if (v === 'sevenDay') {
          [1, 2, 3, 4, 7, 6, 7].forEach((_item, _index) => {
            let _start = new Date(new Date().getTime() - (_item * 24 * 60 * 60 * 1000))
            let _end = new Date(new Date().getTime() - ((_item - 1) * 24 * 60 * 60 * 1000))
            if (_index === 0) {
              _end = new Date(new Date().getTime() - (7 * 1000))
            }
            this.monitorInfo.options = Object.assign({}, this.monitorInfo.options, {
              StartTime: _start,
              EndTime: _end,
              Period: 3600
            })
          })
        }
        this.getEcsMonitorData()
        console.log('time', v)
      },
      loadInstanceStatus () {
        let params = {
          id: this.options.resourceId,
          params: {
            Action: 'DescribeInstances',
            InstanceIds: JSON.stringify([this.options.instanceId])
          }
        }
        this.monitorInfo.instanceStatusInterval = setInterval(() => {
          this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then(d => {
            if (d.Instances.Instance) {
              this.basicInfo.Instances = Object.clone(d.Instances.Instance[0])
              if (this.basicInfo.Instances.Status === 'Running' || this.basicInfo.Instances.Status === 'Stopped') {
                clearInterval(this.monitorInfo.instanceStatusInterval)
              }
            }
          })
        }, 3000)
      },
      changeStatus (status) {
        this.basicInfo.Instances.Status = status
      },
      onShowDialog (type) {
        let option = {
          type: type,
          Instances: this.basicInfo.Instances,
          resourceId: this.options.resourceId
        }
        this.$emit('onShowCloudDialog', option)
      },
      onStart () {
        if (this.basicInfo.Instances && this.options.instanceId) {
          if (this.basicInfo.Instances.Status === 'Stopped') {
          }
        }
      },
      // 关闭侧滑
      onCloseForm () {
        this.options = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.options) {
            this.options = null
            setTimeout(() => {
              this.options = this.items
            }, 300)
          } else {
            this.options = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel,
      Nvd3LineChart
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../../assets/css/variable";

  .cloud-wrapper {
    .ak-defined{
      margin-top:10px;
      div{
        line-height: 18px;
      }
    }
    .el-tabs__header {
      padding: 0;
      margin: 0;
    }
    .el-tabs__content {
      padding: 0;
      .info-content {
        .info-title {
          padding-left: 10px;
          line-height: 30px;
          background-color: $bgColor;
        }
        ul {
          border-top: 1px solid $border-color;
          border-bottom: 1px solid $border-color;
          padding: 20px 17px;
          li {
            height: 30px;
            line-height: 30px;
            .info-name {
              padding-right: 17px;
              text-align: right;
            }
          }
        }
      }
      .select-time {
        padding: 20px;
        height: 67px;
        border-bottom: 1px solid $border-color;
        .el-select {
          width: 120px;
          float: right;
        }
      }
      .show-chart {
        width: 100%;
        .chart-item {
          width: 100%;
          height: 270px;
          .chart-title {
            height: 40px;
            line-height: 40px;
            text-align: center;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// cluster-cloud-ak.vue?7bd116dc